import FakeStore from "@ethico/fakestore";

export const store = new FakeStore("dorks");
